import React from 'react';
import { Redirect } from 'react-router-dom';
import { buildPayoutUri } from 'utils/routes';

const OwnerReportsPage = () => <Redirect to={buildPayoutUri()} />;

export default OwnerReportsPage;
